// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.destinationsHero {
  /* padding: 0 0 em 0; */
  position: relative;
  margin-bottom: 5rem;
}

.destinationsHero__imgContainer {
  height: 40rem;
  /* max-width: 1200px; */
  /* margin: 0 auto; */
  /* margin: 0 -5%; */
  margin: 0 2%;
  border-radius: 1em;
  overflow: hidden;
  position: relative;
}
.destinationsHero__imgContainer::after {
  content: "";
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #14142b25;
}
.destinationsHero__imgContainer img {
  width: 100%;
  height: inherit;
  object-fit: cover;
  object-position: center 55%;
  /* object-position: 0 -15rem; */
}

.destinationsHero__content {
  /* width: 80%; */
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.destinationsHero__title {
  color: var(--clr-light);
  /* font-size: 3.5rem; */
  font-size: 1.25rem;
}

.destinationsHero__title strong {
  display: block;
  margin-top: -0.5rem;
  text-transform: capitalize;
  font-size: 3.5rem;
}
/* 
    .destinationsHero__title span {
      font-weight: bolder;
    } */

.destinationsHero__btn {
  width: 100%;
  justify-content: center;
  height: 3rem;
  border-radius: 1em;
  padding: 0;
}

.destinationsHero__btn span {
  margin-right: 0.5rem;
}

.destinationsHero__btn svg {
  display: block;
  width: 1rem;
}

@media (min-width: 768px) {
  .destinationsHero__imgContainer {
    height: 20rem;
  }

  .destinationsHero__title {
    margin-top: -11rem;
    margin-bottom: 3rem;
  }



  .destinationsHero__content {
    top: 100%;
    left: 50%;
    transform: translate(-50%, -25%);
  }

  .destinationsHero__search > div:first-of-type {
    flex: 1 1 30%;
  }

  .destinationsHero__btn span {
    display: none;
  }

  .destinationsHero__btn {
    flex: 1 1 10%;
    max-width: 3rem;
    border-radius: 50%;
  }

  .destinationsHero__btn svg {
    width: 1.5rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/DestinationsHero/DestinationsHero.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;;;OAGO;;AAEP;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;;;EAIA;IACE,SAAS;IACT,SAAS;IACT,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".destinationsHero {\n  /* padding: 0 0 em 0; */\n  position: relative;\n  margin-bottom: 5rem;\n}\n\n.destinationsHero__imgContainer {\n  height: 40rem;\n  /* max-width: 1200px; */\n  /* margin: 0 auto; */\n  /* margin: 0 -5%; */\n  margin: 0 2%;\n  border-radius: 1em;\n  overflow: hidden;\n  position: relative;\n}\n.destinationsHero__imgContainer::after {\n  content: \"\";\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background-color: #14142b25;\n}\n.destinationsHero__imgContainer img {\n  width: 100%;\n  height: inherit;\n  object-fit: cover;\n  object-position: center 55%;\n  /* object-position: 0 -15rem; */\n}\n\n.destinationsHero__content {\n  /* width: 80%; */\n  width: 80%;\n  max-width: 1200px;\n  margin: 0 auto;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.destinationsHero__title {\n  color: var(--clr-light);\n  /* font-size: 3.5rem; */\n  font-size: 1.25rem;\n}\n\n.destinationsHero__title strong {\n  display: block;\n  margin-top: -0.5rem;\n  text-transform: capitalize;\n  font-size: 3.5rem;\n}\n/* \n    .destinationsHero__title span {\n      font-weight: bolder;\n    } */\n\n.destinationsHero__btn {\n  width: 100%;\n  justify-content: center;\n  height: 3rem;\n  border-radius: 1em;\n  padding: 0;\n}\n\n.destinationsHero__btn span {\n  margin-right: 0.5rem;\n}\n\n.destinationsHero__btn svg {\n  display: block;\n  width: 1rem;\n}\n\n@media (min-width: 768px) {\n  .destinationsHero__imgContainer {\n    height: 20rem;\n  }\n\n  .destinationsHero__title {\n    margin-top: -11rem;\n    margin-bottom: 3rem;\n  }\n\n\n\n  .destinationsHero__content {\n    top: 100%;\n    left: 50%;\n    transform: translate(-50%, -25%);\n  }\n\n  .destinationsHero__search > div:first-of-type {\n    flex: 1 1 30%;\n  }\n\n  .destinationsHero__btn span {\n    display: none;\n  }\n\n  .destinationsHero__btn {\n    flex: 1 1 10%;\n    max-width: 3rem;\n    border-radius: 50%;\n  }\n\n  .destinationsHero__btn svg {\n    width: 1.5rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
